import { render, staticRenderFns } from "./activities-at-petticoat.vue?vue&type=template&id=574c7263&scoped=true&"
import script from "./activities-at-petticoat.vue?vue&type=script&lang=js&"
export * from "./activities-at-petticoat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c7263",
  null
  
)

export default component.exports